import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { Package, PackageToUpdate } from "src/app/shared/types/contract-types";

@Injectable({
  providedIn: "root",
})
export class PackageService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/package/${endpoint}`;
  }

  assignPackage(contracId: number, packageId: number, body: Package) {
    return this.http.put<null>(
      this.apiUrlWithEndpoint(`${packageId}/contract/${contracId}`),
      body,
    );
  }

  updatePackage(tier: PackageToUpdate, id: number): Observable<Package> {
    return this.http.put<Package>(this.apiUrlWithEndpoint(`${id}`), tier);
  }

  getDefaultPackage(): Observable<Package[]> {
    return this.http.get<Package[]>(this.apiUrlWithEndpoint(`default`));
  }

  getPackage(packageId: number): Observable<Package> {
    return this.http.get<Package>(this.apiUrlWithEndpoint(`${packageId}`));
  }
}
